import { apiService } from "api/apiService";
import type { ClassroomLessonClassesResource } from "api/generated";
import { lessonClassListItemFromDto } from "classroom/mappers";
import type { ClassroomLessonClassListItem } from "classroom/types";

// One fetcher for api/my-mentor-classes; the shared student selection layer
// owns it since the actionplan request form started using it too.
export { fetchMyMentorClasses as fetchTeacherMentorClasses } from "shared/api";

export const fetchTeacherLessonGroups = async (): Promise<
  ClassroomLessonClassListItem[]
> => {
  const url = "/api/my-lesson-classes";

  const {
    data: { data },
  } = await apiService.get<{ data: ClassroomLessonClassesResource }>(url);

  return Object.values(data.lesson_classes).map(lessonClassListItemFromDto);
};
